// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-preview-container .public-view {
  position: relative;
  z-index: 0;
}
.form-preview-container .job-ad-simple-header-image {
  position: absolute;
}
/*# sourceMappingURL=index.css.map */`, "",{"version":3,"sources":["webpack://./index.less","webpack://./wp_components/JobAdPreviewContainer/index.less"],"names":[],"mappings":"AAAA;EAEQ,kBAAA;EACA,UAAA;ACAR;ADHA;EAMQ,kBAAA;ACAR;AACA,oCAAoC","sourcesContent":[".form-preview-container {\n    .public-view {\n        position: relative;\n        z-index: 0;\n    }\n    .job-ad-simple-header-image {\n        position: absolute;\n    }\n}\n",".form-preview-container .public-view {\n  position: relative;\n  z-index: 0;\n}\n.form-preview-container .job-ad-simple-header-image {\n  position: absolute;\n}\n/*# sourceMappingURL=index.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
